import { Link } from "react-router-dom";
import { FadeUp, MaskedLineInView } from "@/components/Reveal";
import BlogCard from "@/components/BlogCard";
import blogs from "@/data/blogs";

const InsightsSection = () => (
  <section data-testid="insights-section" className="relative z-10 site-container py-16 sm:py-24">
    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
      <h2 className="text-3xl sm:text-5xl lg:text-[52px] font-normal tracking-tight leading-[1.12] lg:max-w-[820px]">
        <MaskedLineInView>Marketing Insights & Frameworks</MaskedLineInView>
        <MaskedLineInView delay={0.1}>
          <span>
            Built to Drive <span className="text-[#8C5EBA] font-medium">Revenue Growth</span>
          </span>
        </MaskedLineInView>
      </h2>

      <FadeUp delay={0.1}>
      <Link to="/blogs" data-testid="insights-see-more-btn" className="btn-pill btn-outline-accent !py-2.5 !px-6 text-[15px] !font-semibold shrink-0">
        See more
      </Link>
      </FadeUp>
    </div>

    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
      {blogs.slice(0, 3).map((post, i) => (
        <BlogCard key={post.slug} post={post} index={i} showImage />
      ))}
    </div>
  </section>
);

export default InsightsSection;
